import React from "react"

type UserProps = {
  className?: string
}

export function User(props: UserProps) {
  const { className = "" } = props
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.80253 3.33334C10.4495 3.33233 11.0853 3.50135 11.6464 3.82346C12.2074 4.14557 12.674 4.60947 12.9993 5.16868C13.3246 5.72788 13.4973 6.36276 13.4999 7.0097C13.5026 7.65664 13.3352 8.29293 13.0146 8.85481C12.7093 9.38966 12.2754 9.83921 11.7528 10.1631C11.7183 10.1778 11.6859 10.1972 11.6564 10.2207C11.0991 10.5401 10.4681 10.709 9.82544 10.7105C9.17601 10.712 8.53761 10.5426 7.97439 10.2193C7.41118 9.89592 6.943 9.43002 6.6169 8.86839C6.29092 8.30698 6.11839 7.66968 6.11664 7.0205C6.11743 6.37381 6.28808 5.73867 6.61152 5.17866C6.93508 4.61844 7.40018 4.15308 7.96023 3.82922C8.52027 3.50535 9.15559 3.33435 9.80253 3.33334ZM11.9651 11.0024C11.3087 11.3557 10.5744 11.542 9.82743 11.5438C9.0707 11.5456 8.32621 11.358 7.66155 10.9988C6.42569 11.4344 5.34937 12.2348 4.57624 13.2962C3.76863 14.4049 3.33346 15.7412 3.33333 17.1129C3.33331 17.343 3.14675 17.5295 2.91663 17.5295C2.68651 17.5295 2.49998 17.3429 2.5 17.1128C2.50015 15.5648 2.99125 14.0568 3.90266 12.8056C4.65956 11.7665 5.67395 10.949 6.84 10.4297C6.46634 10.1044 6.147 9.71871 5.89624 9.28683C5.49669 8.59872 5.2853 7.81756 5.28331 7.02185L5.2833 7.02039C5.28411 6.2274 5.4933 5.44856 5.8899 4.76188C6.2865 4.0752 6.85659 3.5048 7.54305 3.10782C8.22952 2.71085 9.00825 2.50124 9.80123 2.50001C10.5942 2.49877 11.3736 2.70594 12.0613 3.10076C12.749 3.49559 13.3209 4.06421 13.7196 4.74964C14.1184 5.43508 14.33 6.21327 14.3333 7.00625C14.3365 7.79922 14.1314 8.57914 13.7383 9.26786C13.4868 9.70862 13.164 10.1021 12.7847 10.4333C13.9474 10.9528 14.9588 11.7689 15.714 12.8056C16.6254 14.0568 17.1165 15.5648 17.1166 17.1128C17.1166 17.3429 16.9301 17.5295 16.7 17.5295C16.4699 17.5295 16.2833 17.343 16.2833 17.1129C16.2832 15.7412 15.848 14.4049 15.0404 13.2962C14.2693 12.2377 13.1968 11.4387 11.9651 11.0024Z"
        fill="currentColor"
      />
    </svg>
  )
}
